import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MapView } from './map/MapView';
import { TopBar } from './panels/TopBar';
import { LeftPanel } from './panels/LeftPanel';
import { Inspector } from './panels/Inspector';
import { AdminDrawer } from './admin/AdminDrawer';
import { DataWorkspace } from './data/DataWorkspace';
import { resetGameData } from './data/dataStore';
import { useStore, setState, toast } from './store/store';
import { disposeRealtime, initRealtime, loadMaps, openMap } from './store/data';
import { readUrlState, useUrlSync } from './lib/urlState';
import { errorMessage } from './lib/errors';

export function Workspace() {
  const { t } = useTranslation();
  const mapId = useStore((s) => s.mapId);
  const loading = useStore((s) => s.loading);
  const toastMsg = useStore((s) => s.toast);
  const selectedId = useStore((s) => s.selectedId);
  const view = useStore((s) => s.view);
  useUrlSync();

  useEffect(() => {
    initRealtime();
    (async () => {
      try {
        const maps = await loadMaps();
        const url = readUrlState();
        if (url.view === 'data') setState({ view: 'data' });
        const target = maps.find((m) => m.slug === url.map) ?? maps[0];
        if (target) await openMap(target.id);
        if (url.feature) {
          const f = Object.values(useStore.getState().features).find((x) => x.key === url.feature);
          if (f) setState({ selectedId: f.id });
        }
        if (url.x !== null && url.z !== null) {
          setState({ flyTo: { x: url.x, z: url.z, zoom: url.zoom ?? undefined, seq: -1 } });
        }
      } catch (err) {
        toast(errorMessage(err), 'error');
      }
    })();
    return () => {
      void disposeRealtime();
      void resetGameData();
    };
  }, []);

  return (
    <div className={`workspace${view === 'data' ? ' data-view' : selectedId ? ' has-inspector' : ''}`}>
      <TopBar />
      {/* The map stays mounted (hidden) in the data view so its position survives switching back. */}
      <LeftPanel />
      <main className="center map-center">
        {mapId ? (
          <MapView />
        ) : (
          <div className="splash">{loading ? t('common.loading') : t('app.noMaps')}</div>
        )}
      </main>
      {selectedId && view === 'map' && <Inspector />}
      {view === 'data' && <DataWorkspace />}
      <AdminDrawer />
      {toastMsg && <div className={`toast ${toastMsg.kind}`}>{toastMsg.text}</div>}
    </div>
  );
}
